<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <g clip-path="url(#a)">
    <path d="M13.217 5.891c1.033 0 1.87-.87 1.87-1.945C15.088 2.87 14.25 2 13.218 2c-1.034 0-1.871.871-1.871 1.946 0 1.074.838 1.945 1.87 1.945ZM8.695 16.474C8.64 17.096 6.329 20.326 6 20.91L7.632 22c.425-.595 1.521-2.105 1.925-2.689.337-.485.757-1.006.987-1.581.116-.314.246-.697.381-1.102l-1.51-2.344c-.258.784-.574 1.739-.72 2.19Z"/>
    <path d="M13.95 11.72a.8.8 0 0 0 .347.304l2.998 1.373.705-1.392-2.674-1.421c-.577-.938-1.498-2.456-2.013-3.285-.263-.446-.855-.677-1.34-.63-.542-.081-1.713.17-2.204.653-.338.25-2.04 1.494-2.417 1.772a.822.822 0 0 0-.33.559l-.492 3.905 1.558.231.623-3.51 1.564-1.148-.363 2.692a2.89 2.89 0 0 0 .423 1.933l5.197 8.216 1.67-1.032-4.57-7.224.549-3.252.77 1.255Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
